<template>
    <label class="input__wrap" :style="`width: ${width}`" :disabled="disabled">
        <span class="input__text" v-if="title">{{ title }}{{ (required) ? '*' : '' }}</span>
        <input class="input"
               v-mask="{mask: mask}"
               :class="classObject"
               :type="(isPassword) ? 'password' : 'text'"
               :disabled="disabled"
               :placeholder="placeholder"
               :value="value"
               ref="input"
               :name="name"
               @input="valueChanged"
               @focus="focused"
               @keyup.enter.prevent="keyupEnter"
               :tabindex="1"
        />

        <button v-if="isPassword" class="input-password__showpass-btn" @click.prevent="showPassword" ref="showPassButton">
            <svg class="eye-crossed-icon" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="eye-crossed-icon__cross" d="M17.6765 1.10742L3.32366 14.7217"
                      stroke="currentColor" />
                <path
                        d="M19.9998 7.65094C19.9998 7.65094 15.7976 12.8905 10.3845 12.9282C4.97144 12.9659 1 7.65094 1 7.65094C1 7.65094 5.02115 2.29831 10.3845 2.37371C15.7478 2.44913 19.9998 7.65094 19.9998 7.65094Z"
                        stroke="currentColor" />
                <path
                        d="M10.5004 4.48431C9.99803 4.48461 9.50296 4.6044 9.05606 4.83381C9.32875 4.90861 9.56933 5.07089 9.74082 5.29572C9.9123 5.52054 10.0052 5.79546 10.0053 6.07822C10.0053 6.24773 9.9719 6.41558 9.90704 6.57219C9.84218 6.7288 9.74712 6.8711 9.62725 6.99096C9.50739 7.11082 9.3651 7.20589 9.20849 7.27075C9.05188 7.33561 8.88402 7.36898 8.71451 7.36897C8.46005 7.36883 8.21133 7.29348 7.99957 7.15239C7.78782 7.0113 7.62249 6.81076 7.52437 6.57598C7.39908 6.92057 7.33457 7.28429 7.33374 7.65094C7.33376 8.49078 7.66738 9.29621 8.26124 9.89007C8.85509 10.4839 9.66053 10.8176 10.5004 10.8176C11.3402 10.8176 12.1456 10.4839 12.7395 9.89008C13.3334 9.29622 13.667 8.49078 13.667 7.65094C13.667 6.8111 13.3334 6.00567 12.7395 5.41181C12.1456 4.81795 11.3402 4.48433 10.5004 4.48431Z"
                        fill="currentColor" />
            </svg>
        </button>

        <transition name="scaleDown">
            <span v-if="valid.type" class="input__valid" :class="'input__valid_' + valid.type">
                {{ valid.message }}
<!--                <img v-if=" valid.type === 'error' " src="/img/svg/error_icon.svg" alt="Ошибка" class="input__valid__icon">-->
<!--                <img v-if=" valid.type === 'warning' " src="/img/svg/warning_icon.svg" alt="Внимание" class="input__valid__icon">-->
<!--                <img v-if=" valid.type === 'success' " src="/img/svg/success_icon.svg" alt="Успешно" class="input__valid__icon">-->
            </span>
        </transition>
    </label>
</template>

<script>
import { mask } from '@titou10/v-mask'

export default {
  directives: { mask },
  name: 'app-input',
  props: {
    title: String,
    placeholder: String,
    value: String,
    disabled: Boolean,
    required: Boolean,
    isPassword: Boolean,
    valid: {
      type: Object,
      default: () => {
        return { type: null, message: '' }
      }
    },
    width: {
      type: String,
      default: '100%'
    },
    flat: Boolean,
    borderless: Boolean,
    mask: String,
    name: String
  },
  methods: {
    showPassword () {
      this.$refs.showPassButton.classList.toggle('input-password__showpass-btn_active')
      if (this.$refs.input.getAttribute('type') === 'password') {
        this.$refs.input.setAttribute('type', 'text')
      } else {
        this.$refs.input.setAttribute('type', 'password')
      }
    },
    valueChanged () {
      this.$emit('value-changed', this.$refs.input.value)
    },
    focused () {
      this.$emit('got-focus')
    },
    keyupEnter () {
      this.$emit('keyup-enter')
    }
  },
  computed: {
    classObject () {
      return {
        flat: this.flat,
        borderless: this.borderless,
        'input-password': this.isPassword,
        input_error: this.valid !== {} && this.valid.type === 'error',
        input_warning: this.valid !== {} && this.valid.type === 'warning',
        input_success: this.valid !== {} && this.valid.type === 'success'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.input {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 40px;
  padding: 10px 15px 10px 15px;
  color: $font_color_second;
  border: 1px solid $color_third-dark;
  border-radius: 3px;
  transition: .3s;
  font: inherit;

  &__wrap {
    position: relative;
    display: block;

    &[disabled] {
      pointer-events: none;

      .input__text {
        color: $color_deactive;
      }

      .input {
        border: 1px solid $color_deactive;
      }
    }
  }

  &__text {
    display: block;
    margin-bottom: 10px;
    color: $font_color_second;
    font-weight: 600;
  }

  &__valid {
    display: block;
    position: absolute;
    z-index: 99;
    top: auto;
    bottom: auto;
    transform: translateY(-5px) scaleY(1);
    transform-origin: top;
    left: 0;
    width: 100%;
    font-size: 14px;
    padding: 5px 15px 0 15px;
    color: $font_color_alt;
    border-radius: 0 0 3px 3px;
    transition: .3s;

    &__icon {
      position: absolute;
      top: calc(50% - 12.5px);
      left: auto;
      right: -35px;
      animation: fadeIn .3s linear;

      @media screen and (max-width: $tablet_start) {
        display: none;
      }
    }

    &_error {
      background-color: $color_error;
    }

    &_warning {
      background-color: $color_warning;
    }

    &_success {
      background-color: $color_success;
    }
  }

  &_error {
    border: 1px solid $color_error;
  }

  &_warning {
    border: 1px solid $color_warning;
  }

  &_succes {
    border: 1px solid $color_success;
  }

  &[disabled] {
    background: $color_deactive-bg;
  }

  &:hover {
    border: 1px solid $color_second-light;
  }

  &:focus {
    box-shadow: inset 0 4px 4px rgba(23, 63, 125, 0.25);
  }

  &.flat {
    border: none;

    &:hover {
      border: none;
    }

    &:focus {
      box-shadow: none;
    }
  }

  &.borderless {
    border: none;

    &:hover {
      border: none;
    }
  }
}

.input-password {
  padding-right: 40px;

  &__showpass-btn {
    position: absolute;
    z-index: 10;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0);
    height: 40px;
    padding-right: 10px;
    padding-left: 10px;
    cursor: pointer;
    color: $color_deactive;
    transition: .3s;

    &:hover {
      color: $font_color_main;
    }

    &_active {
      color: $font_color_main;

      .eye-crossed-icon__cross {
        opacity: 0;
      }
    }
  }
}
</style>
